import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchBatchwiseInputReport } from "../../../domain/useages/input-utilization/fetch-batchwise-input-report";
import { RemoteFetchBatchWiseInputReport } from "../../../data/usecases/input-utilization/remote-fetch-batchwise-input-report";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { BatchWiseInputReportDataType } from "../../../domain/models/input-utilization/batchwise-input-report-type";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

interface FetchBatchWiseInputReportInterface {
  fetchBatchWiseInputReport: Function;
  batchWiseInputReportData: BatchWiseInputReportDataType[];
  batchWiseDataFilters: {
    input_ids?: string[];
    role_id?: string;
    product_type?: string;
  };
  fetchBatchWiseDataState: FetchState;
}

const initialStates = {
  batchWiseDataFilters: {},
  batchWiseInputReportData: [],
  fetchBatchWiseDataState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchBatchWiseInputReportSlice: StateCreator<
  FetchBatchWiseInputReportInterface
> = (set, get) => ({
  ...initialStates,
  fetchBatchWiseInputReport: async () => {
    set(() => ({ fetchBatchWiseDataState: FetchState.LOADING }));

    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchBatchwiseInputReport: FetchBatchwiseInputReport =
      new RemoteFetchBatchWiseInputReport(
        `${BASE_URL}${Endpoints.FETCH_BATCH_WISE_INPUT_REPORT}`,
        axiosHttpClient
      );

    let payload = {
      role_id: get().batchWiseDataFilters.role_id,
      input_ids: get().batchWiseDataFilters.input_ids,
      product_type: get().batchWiseDataFilters.product_type,
    };
    let result = await remoteFetchBatchwiseInputReport.fetch(payload);
    if (result.summary.length > 0) {
      set(() => ({
        batchWiseInputReportData: result.summary,
        fetchBatchWiseDataState: FetchState.SUCCESS,
      }));
    } else {
      set({ fetchBatchWiseDataState: FetchState.ERROR });
    }
  },
});
